import * as React from 'react'
import { useShowContext, SimpleShowLayout, Show, useTranslate, Loading, Error } from 'react-admin'
import { Grid, Container, Hidden } from '@mui/material'
import { CardCommon } from '../../../uiElements'
import { ShowListElement } from 'src/components/uiElements/CRUD/ShowListElement'
import { CardCrudBottomButtons } from 'src/components/uiElements/CRUD/CardCrudBottomButtons'

const ShowWrapper = ({ children }) => <Container maxWidth='false'> {children}</Container>

const ShowContent = () => {
  const translate = useTranslate()
  const {
    error, // error returned by dataProvider when it failed to fetch the record. Useful if you want to adapt the view instead of just showing a notification using the `onError` side effect.
    isLoading, // boolean that is true until the record is available for the first time
    record, // record fetched via dataProvider.getOne() based on the id from the location
  } = useShowContext()

  if (isLoading) {
    return <Loading />
  }

  if (error) {
    return <Error />
  }

  return (
    <SimpleShowLayout>
      <CardCommon title={translate('ra.entity.bases')} actions={<CardCrudBottomButtons btnEdit={true} />}>
        <Grid container spacing={3}>
          <ShowListElement label={'ID'} value={record.id} />
          <ShowListElement label={translate('ra.field.name')} value={record.name} />
          <ShowListElement label={translate('ra.field.external_id')} value={record.external_id} />
          <ShowListElement label={translate('ra.field.journal_id')} value={record.journal_id} />
          <ShowListElement label={translate('ra.field.url')} value={record.url} />
          <Hidden mdDown>
            <Grid item md={4} />
          </Hidden>
          <ShowListElement
            label={translate('ra.field.countries')}
            value={record.countries}
            type='json'
          />
          <ShowListElement
            label={translate('ra.field.currencies')}
            value={record.currencies}
            type='json'
          />
          <ShowListElement
            label={translate('ra.field.products')}
            value={record.products}
            type='json'
          />
          <ShowListElement
            label={translate('ra.field.login')}
            value={record.login}
            type='json'
          />
          <ShowListElement
            label={translate('ra.field.config')}
            value={record.config}
            type='json'
          />
        </Grid>
      </CardCommon>
    </SimpleShowLayout>
  )
}

export const BasesShow = (props) => {
  return (
    <Show component={ShowWrapper} {...props} className='CrudShowContainer' actions={null}>
      <ShowContent {...props} />
    </Show>
  )
}
